import { useEffect, useMemo } from 'react'
import { useOutletContext } from 'react-router-dom'
import { observer } from 'mobx-react-lite'
import { layoutStore } from 'shared/layout'
import { ConversationMessages } from 'widgets/ConversationMessages'
import { CallHistoryFilters } from 'pages/conversations/pages/calls/ui/CallHistoryFilters'
import { CallHistory } from 'pages/conversations/pages/calls/ui/CallHistory'
import type { ConversationsTemplateContextType } from 'pages/conversations/layout/ConversationsTemplateLayout/conversationsTemplateLayout'
import {
  ProviderCallsPage,
  useCallsPageContext,
} from 'pages/conversations/pages/calls/context/callsContext'
import { CallsPageStore } from 'pages/conversations/pages/calls/store/callsPageStore'
import { useConversationsPageLayoutContext } from 'pages/conversations/context/conversationsPageLayoutContext'

const CallsPageContent = observer(() => {
  const store = useCallsPageContext()
  const { setList } = useOutletContext<ConversationsTemplateContextType>()
  const { isMobileView } = layoutStore

  const renderList = () => {
    if (isMobileView) return <CallHistory store={store.callHistoryStore} />

    return <CallHistoryFilters store={store.callHistoryStore} />
  }

  useEffect(() => {
    setList(renderList())
  }, [isMobileView])

  return (
    <>
      {isMobileView ? (
        <ConversationMessages store={store.conversationMessagesStore} />
      ) : (
        <CallHistory store={store.callHistoryStore} />
      )}
    </>
  )
})

export const CallsPage = () => {
  const pageLayoutStore = useConversationsPageLayoutContext()
  const store = useMemo(
    () =>
      new CallsPageStore(
        pageLayoutStore.pageLayoutStore,
        pageLayoutStore.callModalStore,
        pageLayoutStore.contactsDetailsManageStore,
        pageLayoutStore.entities
      ),
    []
  )

  return (
    <ProviderCallsPage value={store}>
      <CallsPageContent />
    </ProviderCallsPage>
  )
}
